import React from "react";
import "./error-wrong-channelqty.scss";

const WrongChannelQtyIndicator = props => {
    const { channelQty, channelNames, loc } = props;
    return (
        <h3 className="error-message">
            {loc("errors.wrongChannelQty.required")}
            {loc("errors.wrongChannelQty.observed")}
            <strong> {channelQty}</strong>:<span> </span>
            <span className="error-message__channelNames">({channelNames.join(", ")})</span>.
        </h3>
    );
};

export default WrongChannelQtyIndicator;
